"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlidingDots = exports.Dots = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("styled-components/native");
const S = __importStar(require("./Dots.styles"));
const Dot_1 = require("../../atoms/Dot/Dot");
exports.Dots = ({ count, activeIndex, onDotPress, activeColor, inActiveColor, enabledDotPress, }) => {
    const data = Array.from(Array(count).keys());
    return (react_1.default.createElement(S.PaginationContainer, null, count ? (data.map((_, i) => (react_1.default.createElement(Dot_1.Dot
    // eslint-disable-next-line react/no-array-index-key
    , { 
        // eslint-disable-next-line react/no-array-index-key
        key: i, index: i, enabledDotPress: enabledDotPress, activeIndex: activeIndex, onDotPress: onDotPress, activeColor: activeColor, inActiveColor: inActiveColor })))) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.SlidingDots = ({ count, onDotPress, activeColor, inActiveColor, enabledDotPress, width = 100, scrollX = new react_native_1.Animated.Value(0), }) => {
    const theme = native_1.useTheme();
    const marginHorizontal = 8;
    const dotSize = 10;
    const data = Array.from(Array(count).keys());
    const inputRange = [-width, 0, width];
    const translateX = scrollX.interpolate({
        inputRange,
        outputRange: [
            -dotSize + marginHorizontal * 2,
            0,
            dotSize + marginHorizontal * 2,
        ],
    });
    return (react_1.default.createElement(S.PaginationContainer, { testID: "Sliding-dots-container" },
        react_1.default.createElement(S.DotContainer, null,
            react_1.default.createElement(react_native_1.Animated.View, { style: [
                    {
                        width: dotSize,
                        height: dotSize,
                        borderRadius: dotSize / 2,
                    },
                    {
                        backgroundColor: activeColor || theme.bpCore.colors.link,
                        alignItems: 'center',
                        zIndex: 99,
                        justifyContent: 'center',
                        alignSelf: 'center',
                    },
                    {
                        position: 'absolute',
                        marginHorizontal,
                        transform: [{ translateX }],
                    },
                ] })),
        count ? (data.map((_, i) => (react_1.default.createElement(Dot_1.InActiveDot
        // eslint-disable-next-line react/no-array-index-key
        , { 
            // eslint-disable-next-line react/no-array-index-key
            key: i, index: i, enabledDotPress: enabledDotPress, onDotPress: onDotPress, inActiveColor: inActiveColor })))) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
